import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit,
    Output
} from '@angular/core';
import {ObjectsModalSelectService} from './objects-modal-select.service';
import {ObjectsProvider} from '@providers/objects/objects.provider';
import {ObjectModal} from './object-modal';
import {filter} from 'rxjs/operators';

/**
 * Модалка в выбором объектов.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'objects-modal-select',
    templateUrl: './objects-modal-select.component.html',
    styleUrls: ['./objects-modal-select.component.scss'],
})
export class ObjectsModalSelectComponent implements OnInit, OnChanges, OnDestroy {
    /*
    * Так как компонент используется в удостоверениях и визарде, где объекты хранятся в разном виде,
    * то исполдьзовать FormControl внутри компонента не очень хорошая идея, так как для разных
    * ситуация записывать выбранное значение в FormControl надо будет по-разному.
    * Надежнее будет принимать selectedFormObjects либо в виде строки, либо в виде коллекции
    * и работать с этим.
    * */
    @Input() selectedFormObjects: string|any[];

    /*
    * Метод, для отображения его заголовка в модалке
    * */
    @Input() method = null;

    /*
    * Событие по которому выбранные объекты будут передаваться во внешние компоненты
    * */
    @Output() choose = new EventEmitter();
    @Output() clear = new EventEmitter();

    /*
    * Входящее значение selectedFormObjects будем преобразовывать в массив объектов
    * и записывать в parsedFormObjectsValue
    * */
    public parsedFormObjectsValue: string[] = [];

    /**
     * Строка номеров выбранных объектов, например "2, 3, 4.1, 4.2, 4.4, 6, 7.3"
     */
    public selectedObjectsString: string;

    /**
     * Подписка на объекты. Будем отписываться при удалении компонента
     */
    private subs = [];

    public objects: ObjectModal[] = [];

    constructor(
        public objectsProvider: ObjectsProvider,
        public service: ObjectsModalSelectService,
        private cd: ChangeDetectorRef
    ) {

    }

    ngOnInit() {
        this.subs.push(
            this.objectsProvider.data$.pipe(
                filter((value) => Boolean(value && value.asTree && value.asTree.length)),
            ).subscribe(value => {
                this.objects = value.asTree.map(obj => new ObjectModal(obj));
                this.updateSelectionValue();
                this.cd.detectChanges();
            })
        );
    }

    private updateSelectionValue() {
        this.objects.forEach(item => item.restoreSelectionValue(this.parsedFormObjectsValue));
        this.selectedObjectsString = this.selectedNumbers;
    }

    get selectedNumbers() {
        return this.objects.filter(item => item.selected).map(item => item.getSelectedNumbers()).join(', ');
    }

    /*
    * При изменении selectedFormObjects мапим их в parsedFormObjectsValue в качестве коллекции
    * */
    ngOnChanges() {
        this.parsedFormObjectsValue = this.mapSelectedFormObjectsToArrayOfValues();
        this.updateSelectionValue();
    }

    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }

    onShowModal() {
        this.updateSelectionValue();
        this.cd.detectChanges();
    }

    chooseObjects() {
        this.choose.emit(this.service.getSelectedObjects(this.objects));
        this.updateSelectionValue();
        this.cd.detectChanges();
    }

    clearObjects() {
        this.objects.forEach(item => item.select(false));
        this.selectedObjectsString = this.selectedNumbers;
        this.clear.emit();
        this.cd.detectChanges();
    }

    setSelectionForAll(checked: boolean = true) {
        this.objects.forEach(obj => {
            /**
             * @TODO сначала делаем инверсное действие, потом основное, чтобы статусы всех дочерних объектов сбросились тоже
             */
            obj.select(!checked);
            obj.select(checked);
        });
        this.cd.detectChanges();
    }

    /**
     * Выбранные объекты могут прийти в компонент в двух видах:
     * 1. Коллекция выбранных объектов [{id, number, title, ....}, {...}, ...]
     * 2. Строка с номерами объектов '1, 2.3, 3.1, 3.2, 6'.
     * Нам в работе для отображения первоначальных результатов важно преобразовать это к единой форме - коллекции.
     * @returns {any}
     */
    mapSelectedFormObjectsToArrayOfValues() {
        if (this.selectedFormObjects instanceof Array) {
            return this.selectedFormObjects.map(item => item.number);
        } else if (typeof this.selectedFormObjects === 'string') {
            return this.selectedFormObjects.split(', ');
        } else {
            return [];
        }
    }
}
